import React from 'react';

import {
  ButtonContainer,
  ChallengeButton,
  CMSContainer,
  Header,
  HeadingContainer,
  Heading,
  ContainerBody,
} from './styles';

/**
 * This is an old container used for the challenge management pages, it should not be used anywhere else.
 */

export default function Container(props) {
  const renderButtons = () => {
    if (props.buttonText) {
      return (
        <ButtonContainer>
          <ChallengeButton className="mt-2" disabled={props.disabled} onClick={props.onClick}>
            {props.buttonText}
          </ChallengeButton>
          {props.onClick2 && (
            <ChallengeButton className="mt-2" disabled={props.disabled} onClick={props.onClick2}>
              {`${props.buttonText} v2`}
            </ChallengeButton>
          )}
        </ButtonContainer>
      );
    }
    return null;
  };

  return (
    <CMSContainer>
      {props.history ? (
        <ChallengeButton className="mt-0" onClick={() => props.history.goBack()}>
          <i className="fa fa-arrow-left">&nbsp;</i>Back
        </ChallengeButton>
      ) : null}
      <Header>
        <HeadingContainer>
          <Heading>{props.heading}</Heading>
        </HeadingContainer>
        {renderButtons()}
      </Header>
      <ContainerBody>{props.children}</ContainerBody>
    </CMSContainer>
  );
}
